import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/GeneralComponents/Button";
import DomeCareTitle from "../../components/GeneralComponents/DomeCareTitle";
import { handleSetGetStartedActivated } from "../../redux/slices/orderSessionStorage";
import { handleIsPreventUserNavigation } from "../../redux/slices/orderSlice";
import { clearLocalStorageExceptReduxPersist } from "../../utils/Functions";
import {
  BASE_LOCAL_IMAGES_DIR,
  DefaultNavigateDelay,
} from "../../utils/constants/CommonConstants";
import { internal_server_error_avatar_IMG } from "../../utils/constants/Images";

const InternalServerErrorPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //?==============================================
  const handleBackToHomePage = () => {
    setTimeout(() => {
      clearLocalStorageExceptReduxPersist();
      dispatch(handleIsPreventUserNavigation(false));
      dispatch(handleSetGetStartedActivated(false));
      sessionStorage.setItem("getStartedActivated", "false");
      navigate("/", { replace: true });
    }, DefaultNavigateDelay);
  };
  window.addEventListener("popstate", () => {
    navigate("/", { replace: true });
  });
  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center">
      <div className="absolute left-10 top-10">
        <DomeCareTitle />
      </div>
      <div className="flex flex-col gap-4">
        <img
          src={`${BASE_LOCAL_IMAGES_DIR}/${internal_server_error_avatar_IMG}`}
          alt="avatar"
          loading="lazy"
          className="mx-auto max-w-96"
        />
        <div className="flex flex-col gap-10">
          <div className="flex flex-col items-center gap-1">
            <h1 className="text-2xl font-bold text-headingTextColor">
              {t("internal_server_error_title")}
            </h1>
            <p className="w-4/5 text-center text-base font-normal text-textColor">
              {t("internal_server_error_desc")}
            </p>
          </div>
          <Button
            variant="primary"
            title={t("go_to_home")}
            extraClassName="!w-fit mx-auto"
            onClick={() => handleBackToHomePage()}
          />
        </div>
      </div>
    </section>
  );
};

export default InternalServerErrorPage;
